
import React from 'react';
import {useStore} from '@nanostores/react';

import NavBtnWidget from '../NavBtnWidget.jsx';

import {
    InputWidget, MaskedInputWidget, DateInputWidget, SingleSelectWidget,
    fromLabelValueCb, toLabelValueCb
} from '../../controls/widgets.jsx';

import { $identificationDocumentTypes } from '../../stores/Dictionaries.jsx';


export default ({schema, data, onDataChanged}) => {
    const 
        onDataChangeEventHandler = (value, key) => {
            let diff = {};
            diff[key] = value;
            (onDataChanged || function(){})(diff);
        },
        identificationDocumentTypes = useStore($identificationDocumentTypes),
        //
        docTypeWidgets = {
            'passport-rf': () => (
                <div>
                    <div className="row">
                        <div className="col-md-4">
                            <MaskedInputWidget
                                name="passport_no"
                                title="Серия и номер документа:"
                                placeholder="пример: 94 01 123456"
                                vertical={true}
                                mask="11 11 111111"
                                schema={schema}
                                data={data}
                                onChange={onDataChangeEventHandler}
                            />
                        </div>
                        <div className="col-md-4">
                            <DateInputWidget
                                name="passport_issued_at"
                                title="Дата выдачи:"
                                placeholder="пример: 01.01.1990"
                                vertical={true}
                                schema={schema}
                                data={data}
                                onChange={onDataChangeEventHandler}
                            />
                        </div>
                        <div className="col-md-4">
                            <MaskedInputWidget
                                name="passport_code"
                                title="Код подразделения:"
                                placeholder="пример: 111-111"
                                vertical={true}
                                mask="111-111"
                                schema={schema}
                                data={data}
                                onChange={onDataChangeEventHandler}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <InputWidget
                                type="textarea"
                                name="passport_issued_by"
                                title="Кем выдан:"
                                placeholder="Отделение УФМС России..."
                                vertical={true}
                                schema={schema}
                                data={data}
                                onChange={onDataChangeEventHandler}
                            />
                        </div>
                    </div>
                </div>
            ),
            'passport-other': () => (
                <div>
                    <div className="form-group">
                        <InputWidget
                            type="textarea"
                            name="document_description"
                            title="Документ, удостоверяющий личность:"
                            placeholder="вид документа, серия и номер, дата выдачи, кем выдан"
                            vertical={true}
                            schema={schema}
                            data={data}
                            onChange={onDataChangeEventHandler}
                        />
                    </div>
                    <div className="form-group">
                        <InputWidget
                            name="citizenship"
                            title="Гражданство:"
                            placeholder="Укажите ваше гражданство (например, Российская Федерация)"
                            vertical={true}
                            schema={schema}
                            data={data}
                            onChange={onDataChangeEventHandler}
                        />
                    </div>
                </div>
            )
        },

        selDocTypeObj = data['document_type'] || identificationDocumentTypes[0].value;
        if (_.isEmpty(data['document_type'])) data['document_type'] = selDocTypeObj;

        return (
            <form className="form">
                
                <div className="card border-primary">
                    <div className="card-header text-bg-primary">Удостоверение личности</div>

                    <div className="card-body">

                        <div className="row">
                            <div className="col-md-12">
                                <SingleSelectWidget
                                    name="document_type"
                                    title="Тип документа:"
                                    cbFromData={fromLabelValueCb}
                                    cbToData={toLabelValueCb}
                                    vertical={true}
                                    options={identificationDocumentTypes}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                    />
                            </div>
                        </div>

                        {docTypeWidgets[selDocTypeObj]?docTypeWidgets[selDocTypeObj]():null}

                        <div className="row">
                            <div className="col-md-6">
                                <DateInputWidget
                                    name="birth_date"
                                    title="Дата рождения:"
                                    placeholder="например, 01.01.1990"
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                />
                            </div>
                            <div className="col-md-6">
                                <InputWidget
                                    name="birth_place"
                                    title="Место рождения:"
                                    placeholder="например, Ижевск"
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card border-primary mt-2">
                    <div className="card-header text-bg-primary">Адрес</div>
                    <div className="card-body form-horizontal">
                        <div className="row">
                            <div className="col-md-12">
                                <InputWidget
                                    type="textarea"
                                    name="address_reg"
                                    title="Адрес регистрации:"
                                    placeholder="Город, улица, дом, квартира"
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <InputWidget
                                    name="address_reg_is_living"
                                    type="checkbox"
                                    title="Я проживаю по адресу регистрации"
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                />
                            </div>
                        </div>
                        {
                            !data.address_reg_is_living ? (
                                <div className="row">
                                    <div className="col-md-12">
                                        <InputWidget
                                            type="textarea"
                                            name="address_living"
                                            title="Адрес проживания:"
                                            placeholder="Город, улица, дом, квартира"
                                            schema={schema}
                                            data={data}
                                            onChange={onDataChangeEventHandler}
                                        />
                                    </div>
                                </div>
                            ) : null
                        }
                    </div>

                </div>

                <div className="card border-primary mt-2">
                    <div className="card-header text-bg-primary">Документы</div>
                    <div className="card-body form-horizontal">
                        <div className="row">
                            <div className="col-md-12">
                                <MaskedInputWidget
                                    name="ssn_id"
                                    title="СНИЛС"
                                    placeholder="Введите номер СНИЛС"
                                    mask="111-111-111 11"
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                />
                            </div>
                            <div className="col-md-12">
                                <MaskedInputWidget
                                    name="tax_id"
                                    title="ИНН"
                                    placeholder="Введите номер ИНН"
                                    mask="111111111100"
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <NavBtnWidget to="/education" />

            </form>
        );
    }


